module.exports = __webpack_public_path__ + "static/img/12.3f2d5435.jpg";